import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/dedupe';
import ReCAPTCHA from 'react-google-recaptcha';

export default function GoogleRecaptcha(props) {
  const { className, type, theme, sitekey, tabindex, onChange, onErrored, onExpired, hl, size, badge } = props;
  const classnames = classNames('recaptcha', className);

  // set removeRecaptcha value to force to rebuild recaptcha component.
  const [removeRecaptcha, setRemoveRecaptcha] = useState(false);

  useEffect(() => {
    setRemoveRecaptcha(true);
    setTimeout(() => {
      setRemoveRecaptcha(false);
    }, 0);
  }, [hl]);

  return (
    (removeRecaptcha) ? '' :
      <ReCAPTCHA
        className={classnames}
        theme={theme}
        type={type}
        sitekey={sitekey}
        tabindex={tabindex}
        onErrored={onErrored}
        onExpired={onExpired}
        onChange={onChange}
        hl={hl}
        size={size}
        badge={badge}
      />
  );
}

GoogleRecaptcha.propTypes = {
  className: PropTypes.string,
  sitekey: PropTypes.string.isRequired,
  theme: PropTypes.string,
  type: PropTypes.string,
  tabindex: PropTypes.number,
  onErrored: PropTypes.func,
  onExpired: PropTypes.func,
  onChange: PropTypes.func,
  hl: PropTypes.string,
  size: PropTypes.string,
  badge: PropTypes.string
};

GoogleRecaptcha.defaultProps = {
  className: '',
  theme: 'light',
  type: 'image',
  tabindex: 0,
  onErrored: () => {},
  onExpired: () => {},
  onChange: () => {},
  hl: '',
  size: 'normal',
  badge: 'inline'
};
